import { createI18n } from 'vue-i18n'
import env from '@/env'
import { DEFAULT_LANGUAGE } from '@/enum/generic'
import { withTranslationFallback } from '@/helpers/i18nSafeTranslate'

export function loadLocaleMessages () {
    const locales = import.meta.glob('./locales/*.json',  { eager: true })

    const messages = {}

    for (const path in locales) {
        const match = path.match(/locales\/([a-z0-9]+)\.json$/)

        if (match) {
            const locale = match[1]

            messages[locale] = locales[path].default
        }
    }

    return messages
}

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: DEFAULT_LANGUAGE.locale,
    fallbackLocale: env.VITE_APP_I18N_FALLBACK_LOCALE || 'en',
    // CMS/TagsList use dotted keys as flat properties; default path resolver nests them
    messageResolver: (messages, path) =>
        messages != null && typeof messages === 'object' && Object.prototype.hasOwnProperty.call(messages, path)
            ? messages[path]
            : null,
    messages: loadLocaleMessages(),
})

i18n.global.t = withTranslationFallback(i18n.global)

/**
 * The functions defined in this module are temporary utilities designed to simplify the workflow of translating the project.
 *
 * TODO: remove later
 */
/* --- START --- */
window.translationsHistoryMap = new Map()

const translationsHistoryMap = window.translationsHistoryMap
const translationHistoryTrackEnabledStorageKey = 'translationHistoryTrackEnabled'
const translationHistoryKeyDivider = '_|_|_'

function formTranslationHistoryKey (key, translation) {
    return `${key}${translationHistoryKeyDivider}${translation}`
}
function destructTranslationHistoryKey (key) {
    return key.split(translationHistoryKeyDivider)
}
function getTranslationsHistory () {
    console.group('Translations History')

    for (const [ key, translation ] of translationsHistoryMap) {
        const [ keyPart ] = destructTranslationHistoryKey(key)
        logTranslation(keyPart, translation)
    }

    console.groupEnd()
}
function getTranslation (translation) {
    const translationFromHistory = translationsHistoryMap.entries().find(t => t[1].toLowerCase().trim() === translation.toLowerCase().trim())

    if (!translationFromHistory) {
        console.error('Translation not found')
    } else {
        const [ key ] = destructTranslationHistoryKey(translationFromHistory[0])

        logTranslation(key, translation)
    }
}
export function isTranslationHistoryTrackEnabled () {
    return localStorage.getItem(translationHistoryTrackEnabledStorageKey) === 'true'
}
function setTranslationHistoryTrackEnabled (enabled) {
    localStorage.setItem(translationHistoryTrackEnabledStorageKey, enabled.toString())

    if (enabled) {
        window.location.reload()
    } else {
        translationsHistoryMap.clear()
    }
}
function logTranslation (key, translation) {
    console.log('%c[i18n]%c ' + key, 'font-weight: bold; color: #ff00ff;', 'font-weight: bold; color: #00ffff;', translation)
}

window.getTranslationsHistory = getTranslationsHistory
window.getTranslation = getTranslation
window.setTranslationHistoryTrackEnabled = setTranslationHistoryTrackEnabled

if (isTranslationHistoryTrackEnabled()) {
    const originalT = i18n.global.t
    i18n.global.t = function (key, ...args) {
        const translation = originalT.call(this, key, ...args)

        const keyForHistory = formTranslationHistoryKey(key, translation)

        if (!translationsHistoryMap.has(keyForHistory)) {
            translationsHistoryMap.set(keyForHistory, translation)
        }

        return translation
    }
}
/* --- END --- */

export default i18n
